import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Region} from './region.model';
import {ApiService} from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class RegionsService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getAll(): Observable<Region[]> {
    return this.apiService.get<Region[]>('/account/regions');
  }
}
